import { SxProps, Theme } from "@mui/material/styles";

export const captainBannerContainer: SxProps<Theme> = (theme) => ({
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height: "120px",
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
    zIndex: 1,
    fontFamily: "HsvSans-Regular",
});

export const captainFirstName: SxProps<Theme> = (theme) => ({
    fontWeight: "500",
    fontSize: "1.2rem",
    color: theme.palette.primary.main,
    fontFamily: "HsvSlab",
    lineHeight: "1.2",
});

export const captainLastName: SxProps<Theme> = (theme) => ({
    fontWeight: "700",
    fontSize: "1.8rem",
    color: theme.palette.primary.main,
    fontFamily: "HsvSlab",
    lineHeight: "1.4",
});

export const captainActivity: SxProps<Theme> = (theme) => ({
    fontWeight: "bold",
    fontSize: "0.9rem",
    color: theme.palette.text.primary,
    fontFamily: "HsvSlab",
    lineHeight: "1.2",
});

export const flagBox: SxProps<Theme> = {
    width: 80,
    height: 100,
};
